import { create } from 'zustand';
import type { User, Subscription, Transaction, Plan } from '@/types';

interface AppState {
  // User state
  user: User | null;
  balance: number;
  isLoading: boolean;
  error: string | null;

  // Subscription state
  activeSubscription: Subscription | null;
  plans: Plan[];

  // Transaction state
  transactions: Transaction[];

  // Actions
  setUser: (user: User | null) => void;
  setBalance: (balance: number) => void;
  setActiveSubscription: (subscription: Subscription | null) => void;
  setPlans: (plans: Plan[]) => void;
  setTransactions: (transactions: Transaction[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  reset: () => void;
}

const initialState = {
  user: null,
  balance: 0,
  isLoading: false,
  error: null,
  activeSubscription: null,
  plans: [],
  transactions: [],
};

export const useStore = create<AppState>((set) => ({
  ...initialState,

  setUser: (user) => set({ user }),
  setBalance: (balance) => set({ balance }),
  setActiveSubscription: (subscription) => set({ activeSubscription: subscription }),
  setPlans: (plans) => set({ plans }),
  setTransactions: (transactions) => set({ transactions }),
  setLoading: (loading) => set({ isLoading: loading }),
  setError: (error) => set({ error }),
  reset: () => set(initialState),
}));
